import * as React from "react";
import type { FoldStep } from "~/hooks/useBottomSheet";

interface BottomSheetContextValue {
  step: FoldStep;
  setStep: (step: FoldStep) => void;
  dragging: boolean;
}

export const BottomSheetContext = React.createContext<BottomSheetContextValue | null>(null);
